/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { Flex, Heading } from "@chakra-ui/react"
import { breadCrumbFirstLevel, headerFooterContentWidth, headerFooterMaxWidth } from "../../common/commonConstants"
import { SubPage, SubPageContent } from "../../components/SubPage"
import { BreadCrumb } from "../../components/commons/breadcrumb"
import { Colors } from "../../theme/colors"
import { FMPFilterForm } from "../fmp/productFilter/productFilter.support.form"
import { PublicFilterTable } from "./productFilter.public.table"

export const PublicProductFilter = (): JSX.Element => {
  return (
    <SubPage>
      <BreadCrumb
        options={{
          ...breadCrumbFirstLevel,
          thirdLevel: { title: "Product Filter" }
        }}
      />
      <SubPageContent props={{ pt: "22px" }} innerBoxProps={{ w: headerFooterContentWidth, maxW: headerFooterMaxWidth }}>
        <Flex justifyContent="flex-start" alignItems="center" w="100%" pb="2" mb="3" borderBottom={`2px solid ${Colors.Primary.accent}`}>
          <Heading variant={"RHeading1"} textAlign="left" color="primary">
            Product Filter
          </Heading>
        </Flex>

        <FMPFilterForm />
        <PublicFilterTable />
      </SubPageContent>
    </SubPage>
  )
}
